(function() {
    
  const SELECTOR = '[data-animate]';
  let observer;

  function initObserver() {
    if ('IntersectionObserver' in window === false) {
      // Fallback: reveal everything
      document.querySelectorAll(SELECTOR).forEach(el => el.classList.add('is-inview'));
      return;
    }

    observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const el = entry.target;
        if (entry.isIntersecting) {
          el.classList.add('is-inview');
          if (el.dataset.animateOnce !== 'false') {
            observer.unobserve(el); // reveal once by default
          }
        } else {
          // If you want repeat animations, set data-animate-once="false"
          if (el.dataset.animateOnce === 'false') {
            el.classList.remove('is-inview');
          }
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -10% 0px', // reveal just before fully in view
      threshold: 0.1
    });

    document.querySelectorAll(SELECTOR).forEach(el => observer.observe(el));
  }

  function destroyObserver() {
    if (observer) observer.disconnect();
  }

  // Init on load
  document.addEventListener('DOMContentLoaded', initObserver);

  // Shopify Theme Editor: re-init when sections are added/changed
  document.addEventListener('shopify:section:load', initObserver);
  document.addEventListener('shopify:section:unload', destroyObserver);
  document.addEventListener('shopify:block:select', initObserver);
  document.addEventListener('shopify:block:deselect', initObserver);
})();
